class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.handleOnSummaryHover();

    this.addEventListener("keyup", onKeyUpEscape);
    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );

    const slideshowWrapper = this.querySelector(
      ".collection-list-slideshow-parent"
    );

    this.image = slideshowWrapper?.querySelector("img");

    if (slideshowWrapper) {
      slideshowWrapper.previousElementSibling
        .querySelectorAll("a")
        .forEach((a) => {
          a.addEventListener("mouseenter", this.handleOnCollectionMouseEnter);
        });

      slideshowWrapper.previousElementSibling
        .querySelectorAll("a")
        .forEach((a) => {
          a.addEventListener("mouseleave", this.handleOnCollectionMouseLeave);
        });
    }

    this.querySelector(".collection-list-close-button")?.addEventListener(
      "click",
      () => this.close()
    );
  }

  handleOnSummaryHover() {
    const stickyHeader = document.querySelector("sticky-header");
    const menu = stickyHeader.querySelector(
      "#main-header > nav.header__inline-menu"
    );
    let a = this.mainDetailsToggle.parentElement;
    const parents = [];
    while (a) {
      parents.unshift(a);
      a = a.parentNode;
    }

    if (!parents.includes(menu) && window.innerWidth <= 750) return;

    this.mainDetailsToggle.onclick = () => false;

    const anchors = this.mainDetailsToggle.querySelectorAll("a");
    if (anchors?.length) {
      anchors.forEach((a) =>
        a.addEventListener("click", (e) => e.stopPropagation())
      );
    }

    const summary = this.mainDetailsToggle.firstElementChild;

    const handleOnMouseEnter = (e) => {
      const allDetails = menu.querySelectorAll("details");
      if (!allDetails?.length) return;
      allDetails.forEach((t) => t.removeAttribute("open"));
      this.mainDetailsToggle.setAttribute("open", "true");
      this.handleHeaderTransparency(
        !stickyHeader.classList.contains("header-transparent")
      );
    };

    const handleOnMouseLeave = (e) => {
      this.close();
    };

    summary.addEventListener("mouseenter", handleOnMouseEnter);
    summary.nextElementSibling.addEventListener(
      "mouseleave",
      handleOnMouseLeave
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  handleHeaderTransparency(never) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (
      location.pathname === "/" ||
      location.pathname === "/ar" ||
      location.pathname === "/fr" || 
      location.pathname === "/pages/hugo" || 
      location.pathname === "/pages/boss"
    ) {
      const stickyHeader = document.querySelector("sticky-header");
      const headerType = stickyHeader.dataset.type;
      if (headerType === 'header-no-transparent') return;
      if (!stickyHeader || never) return;
      const thisContainsTransparentClass =
        stickyHeader.classList.contains("header-transparent");

      if (thisContainsTransparentClass) {
        stickyHeader.classList.remove("header-transparent");
        return;
      }

      if (scrollTop < 80) {
        if (!thisContainsTransparentClass) {
          stickyHeader.classList.add("header-transparent");
        }
      } else {
        if (thisContainsTransparentClass) {
          stickyHeader.classList.remove("header-transparent");
        }
      }
    }
  }

  close() {
    this.handleHeaderTransparency();
    this.mainDetailsToggle.removeAttribute("open");
  }

  handleOnCollectionMouseEnter = (e) => {
    const img = e.currentTarget.dataset.collectionImage;

    if (img.includes("no-image")) {
      this.image.style.opacity = "0";
    } else {
      this.image.style.opacity = "1";
      this.image.src = img;
    }
  };

  handleOnCollectionMouseLeave = (e) => {
    this.image.style.opacity = "0";
  };
}

customElements.define("details-disclosure", DetailsDisclosure);
